import { useEffect, useState } from "react";

export const useCooldown = (seconds: number, initialState = false) => {
  const [isOnCooldown, setIsOnCooldown] = useState(initialState);

  useEffect(() => {
    if (isOnCooldown) {
      setTimeout(() => {
        setIsOnCooldown(false);
      }, seconds * 1000);
    }
  }, [isOnCooldown, seconds]);

  return { isOnCooldown, setIsOnCooldown };
};
